import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/conversations/$threadId/")({
  staticData: {
    breadcrumb: false,
  },
  component: ThreadDetailIndexRoute,
})

function ThreadDetailIndexRoute() {
  return null
}
